const DuolingoRoutes = [
    {
        path: '/duolingo-price-in-different-countries',
        name: 'Duolingo',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/en/duolingo-price-in-different-countries',
        name: 'DuolingoEN',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/cn/duolingo-price-in-different-countries',
        name: 'DuolingoCN',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/de/duolingo-price-in-different-countries',
        name: 'DuolingoDE',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/es/duolingo-price-in-different-countries',
        name: 'DuolingoES',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/br/duolingo-price-in-different-countries',
        name: 'DuolingoBR',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/fr/duolingo-price-in-different-countries',
        name: 'DuolingoFR',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/it/duolingo-price-in-different-countries',
        name: 'DuolingoIT',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/jp/duolingo-price-in-different-countries',
        name: 'DuolingJP',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/ko/duolingo-price-in-different-countries',
        name: 'DuolingoKO',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    },
    {
        path: '/ru/duolingo-price-in-different-countries',
        name: 'DuolingoRU',
        component: () => import(/* webpackChunkName: "duolingo" */'@/views/3-in-1/duolingo/Duolingo.vue')
    }
]

export default DuolingoRoutes;
